<template>
  <v-container fluid class="pa-0 parent_conatiner" ref="container"> <!-- @keydown="keyEvent" @keyup="jumpToItem" -->

    <v-row no-gutters ref="header">
      <v-col cols="12">
        <slot name="header">
          <ListToolbar v-model="itemList" :pk="pk" :objectName="'servicesystem.common_objects.machine.machines'">
            <template v-slot:toolbar-content-left>
              <template v-if="!$route.query[pk + 'filter']">
                <FilterTabs :pk="pk" :showFilterTab="showFilterTab" :showSortingTab="showSortingTab"
                  :showClearFilter="showClearFilter" :showSearch="showSearch" />
              </template>
              <FilterSearch v-if="showSearch && $route.query[pk + 'filter']" :pk="pk" />
              <v-btn v-if="exportFunction != undefined" icon color="success"
                @click="exportFunction(FiltersAndPagination)">
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <template v-slot:toolbar-content-right>
              {{ (loading || !totalItems) ? '' : totalItems }}
              <RefreshBtn :method="() => { fetch() }" :externalLoading="loading"
                :tip="$t('servicesystem.common_objects.commonterms.refresh_list')" :size="'small'" class="ml-2">
              </RefreshBtn>
            </template>
          </ListToolbar>
        </slot>
      </v-col>
    </v-row>

    <QScroll :list="itemList" :loading="loading" :skeletonloading="true" :height="listHeight" :pagination="pagination"
      :groupBy="groupBy" :groupSort="groupSort" :groupItemSort="groupItemSort" :scrollcheckTrigger="scrollcheckTrigger"
      @loadNextPage="loadNextPage()">

      <template v-slot:prepend-item>
        <slot name="prepend-item" :list="itemList" :listloading="loading" />
      </template>

      <template v-slot:group-header="{ group, items }">
        <slot name="group-header" :group="group" :items="items" />
      </template>
      <template v-slot:subgroup-header="{ group, items }">
        <slot name="subgroup-header" :group="group" :items="items" />
      </template>

      <template v-slot:list-item="{ item, index, groupIndex }">
        <!-- <div tabindex="0" class="focustarget-listitem" :ref="'list-item-' + index" :id="'list-item-' + index"
          :style="index == jumpToIndex && itemFocused ? 'border: 1px solid var(--v-primary-base);' : ''"
          @click="e => { log(e); log(index); focusListItem(index); e.target.focus() }">
          :style="index == jumpToIndex && itemFocused ? 'border: 1px solid var(--v-primary-base);' : ''" -->
        <slot name="list-item" :index="index" :item="item" :groupIndex="groupIndex" :handleadded="handleadded"
          :handlechanged="handlechanged" :handleremoved="handleremoved">
          <v-list-item>
            <pre>{{ item }}</pre>
          </v-list-item>
        </slot>
        <!--</div>-->
      </template>

      <template v-slot:empty-filtered-list>
        <empty-page :icon="'mdi-filter-remove'"
          :title="$t('servicesystem.common_objects.fallbackterms.empty_filter', { okey: $t('servicesystem.common_objects.machine.machines').toLowerCase() })"
          :message="$t('servicesystem.common_objects.fallbackterms.empty_filter_body')" class="ignoreodd">
        </empty-page>
      </template>

      <template v-slot:empty-list>
        <empty-page :icon="'mdi-playlist-remove'" :title="$t('servicesystem.common_objects.fallbackterms.empty_list')"
          :message="$t('servicesystem.common_objects.fallbackterms.empty_list_body')" class="ignoreodd">
          <template v-slot:actions>
            <slot name="empty-list-actions" />
          </template>
        </empty-page>
      </template>
    </QScroll>

    <!-- the hideFooter prop can be used to dynamically reclaim hight allocated to the footer slot on mount -->
    <v-row no-gutters ref="footer" :style="hideFooter ? 'position: absolute; z-index: -1; opacity: 0;' : ''">
      <v-col cols="12">
        <slot name="footer">
        </slot>
      </v-col>
    </v-row>

    <!-- {{ itemFocused }} {{ focusedIndex }} {{ jumpToIndex }} -->

    <slot name="dialog" :item="dialogItem" :readonly="dialogReadonly" :trigger="dialogTrigger" :closeTrigger="internalDialogCloseTrigger"
      :handleadded="handleadded" :handlechanged="handlechanged">
      <ConfigDialog v-if="dialogMethodConfig" :methodconfigurations="dialogMethodConfig"
        :externaltrigger="dialogTrigger" :externalclosetrigger="internalDialogCloseTrigger" :item="dialogItem" :readonly="dialogReadonly"
        @Added="handleadded" @Changed="handlechanged">
        <template v-slot:dialog-content="{ trigger, edititem, handlevalid, readonly }">
          <slot name="dialog-content" :item="edititem" :trigger="trigger" :handlevalid="handlevalid" :readonly="readonly" />
        </template>

        <template v-slot:center-button="{ edititem, }">
          <slot name="center-button" :item="edititem" />
        </template>
      </ConfigDialog>
    </slot>

  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";
import ConfigDialog from "@/components/Dialogs/ConfigDialog.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListToolbar from "@/views/admin/machines/ListToolbar.vue";
import FilterSearch from "@/views/layouts/FilterSearch.vue";
import FilterTabs from "@/views/layouts/FilterTabs.vue";
import Vue from "vue";


export default {
  name: "ListPane",
  props: {
    pk: String,
    showFilterTab: Boolean,
    showSortingTab: Boolean,
    showSearch: {
      type: Boolean,
      default: true
    },
    showClearFilter: {
      type: Boolean,
      default: true
    },
    optionalFilters: Object,
    lockedFilters: Object,
    getListMethod: {
      type: Function,
      required: true
    },
    paginationEnabled: Boolean,
    itemsPerPage: Number,
    dialogTrigger: Number,
    dialogCloseTrigger: Number,
    dialogItem: Object,
    dialogMethodConfig: Object,
    setPreviewFunction: Function,
    openFunction: Function,
    itemValueKey: {
      type: String,
      default: "Id"
    },
    hideFooter: Boolean,
    exportFunction: Function,
    groupBy: [Function, String, Array],
    groupSort: Function,
    groupItemSort: Function,
    scrollcheckTrigger: Number,
    dialogReadonly: {
      type: Boolean,
      default: false
    },
  },
  components: {
    QScroll,
    FilterTabs,
    FilterSearch,
    EmptyPage,
    ListToolbar,
    RefreshBtn,
    ConfigDialog,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data: () => ({
    itemList: null,
    loading: false,
    sucess: true,
    pagination: {
      page: 1,
      itemsPerPage: 100,
      nextPageLoading: false,
      partialPageReached: false,
    },
    mounted: false,
    focusedIndex: 0,
    jumpToIndex: 0,
    itemFocused: false,
    lastMove: 0,
    internalDialogCloseTrigger: 1,
    cancelTokenContollerList: [],
    totalItems: 0,

    currentRequestSeq: 0,
  }),
  /*
  created() {
    document.addEventListener("focusin", this.focusChanged);
  },
  */
  mounted() {
    if (this.itemsPerPage) {
      this.pagination.itemsPerPage = this.itemsPerPage;
    }
    this.fetch();
    this.mounted = true;
  },
  /*
  beforeDestroy() {
   document.removeEventListener("focusin", this.focusChanged);
  },
  */

  beforeDestroy() {
    this.cancelAllOpenRequests();
  },

  methods: {
    cancelAllOpenRequests() {
      for (const controller of this.cancelTokenContollerList) {
        controller.abort();
      }
      this.cancelTokenContollerList = [];
      //console.log('cancelAllOpenRequests');
    },

    isAbort(err) {
      return err?.name === 'AbortError' || err?.code === 'ERR_CANCELED' || /aborted/i.test(err?.message || '');
    },

    async fetch() {
      this.cancelAllOpenRequests();

      const seq = ++this.currentRequestSeq; // mark this call as the latest
      this.loading = true;
      this.itemList = null;
      Vue.set(this.pagination, "page", 1);

      try {
        const list = await this.getListFromFilter();
        // If another fetch started after this one, bail without touching state
        if (seq !== this.currentRequestSeq) return;

        this.itemList = list;
      } catch (e) {
        // Ignore aborts completely
        if (this.isAbort(e)) return;
        // Only the latest request may flip success/error state
        if (seq === this.currentRequestSeq) {
          this.sucess = false;
          this.itemList = [];
          console.error('fetch error', e);
        }
      } finally {
        // Only the latest request may end the loading state
        if (seq === this.currentRequestSeq) {
          this.loading = false;
        }
      }
    },

    async getListFromFilter() {
      const controller = new AbortController();
      const cancelationToken = controller.signal;
      this.cancelTokenContollerList.push(controller);

      const filter = Object.assign({}, this.FiltersAndPagination);

      try {
        const response = await this.getListMethod(filter, cancelationToken);
        this.sucess = true;

        let items = response;
        if (items.Content) {
          this.totalItems = response.TotalCount;
          items = response.Content;
        }

        const endReached = !this.paginationEnabled || items.length < this.pagination.itemsPerPage;
        Vue.set(this.pagination, "partialPageReached", endReached);

        return items;
      } catch (e) {
        if (this.isAbort(e)) {
          // Re-throw so outer fetch() can ignore gracefully
          throw e;
        }
        console.error('getListFromFilter error', e, controller);
        this.sucess = false;
        return [];
      }
    },

    async loadNextPage() {
      this.pagination.page++;
      Vue.set(this.pagination, "nextPageLoading", true);
      try {
        const list = await this.getListFromFilter();
        list.forEach(o => this.itemList.push(o));
      } catch (e) {
        if (!this.isAbort(e)) console.error('loadNextPage error', e);
      } finally {
        Vue.set(this.pagination, "nextPageLoading", false);
      }
    },

    handleadded(item) {
      this.itemList.unshift(item);
      this.$emit('Added', item);
    },

    handlechanged(item) {
      const idKey = this.itemValueKey;
      var existingIndex = this.itemList.findIndex(x => x[idKey] == item[idKey]);
      Vue.set(this.itemList, existingIndex, item);
      this.$emit('Changed', item);
    },

    handleremoved(item) {
      const idKey = this.itemValueKey;
      var existingIndex = this.itemList.findIndex(x => x[idKey] == item[idKey]);
      //console.log('handleremoved', item, existingIndex);
      Vue.delete(this.itemList, existingIndex);
      this.$emit('Removed', item);
    },
  },

  computed: {
    addedfilters() {
      if (this.optionalFilters || this.lockedFilters) {
        var filters = Object.assign({}, this.optionalFilters);
        if (this.lockedFilters) {
          for (const key in this.lockedFilters) {
            filters[key] = this.lockedFilters[key]
          }
        }
        return filters;
      }
      else {
        return null;
      }
    },

    FiltersAndPagination() {
      var item = Object.assign({}, this.addedfilters);
      if (this.paginationEnabled) {
        item.ItemsPerPage = this.pagination.itemsPerPage;
        item.Page = this.pagination.page;
      }
      return item;
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },
    headerHeight() {
      //console.log('refs', this.$refs);
      return this.mounted && this.$refs.header.clientHeight || 0;
    },
    footerHeight() {
      return this.mounted && !this.hideFooter && this.$refs.footer.clientHeight || 0;
    },
    listHeight() {
      //console.log('refs', this.$refs);
      //console.log('headerHeight', this.headerHeight, 'footerHeight', this.footerHeight);
      return this.contentHeight - (this.headerHeight + this.footerHeight);
    },
  },

  watch: {
    "$route.query.timestamp"() {
      this.fetch();
    },

    footerHeight: function () {
      //console.log('footerHeight', this.footerHeight);
    },

    dialogCloseTrigger() {
      this.internalDialogCloseTrigger++;
    },

    "$route.name"() {
      this.internalDialogCloseTrigger++;
    },

    addedfilters: function (newVal, oldVal) {
      if (!this.SameValue(newVal, oldVal)) {
        this.fetch();
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.parent_conatiner {
  position: relative;
  display: flex;
  flex-flow: column;
  max-height: 100%;
}
</style>